<template>
  <div>
    <Navbar />
    <main>
      <section class="brand-colors--green with-bg">
        <div class="container bg-guy">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 py-4 py-md-7">
              <h1 class="type-mono">We Are Hiring</h1>
            </div>
          </div>
        </div>
      </section>
      <section class="container py-5">
        <vue-markdown class="job-description">
        <!-- eslint-disable -->
# Regulatory Compliance Intern (Master's Level) ・ International Market Expansion

## Job description

As part of our team, you will be performing essential regulatory analysis focused on Open Banking legislation in markets outside of the European Economic Area (EEA). Through this work, you will be tasked with finding the specific requirements for applying for necessary authorisations required to operate in selected international markets. You will gain deep knowledge about global Open Banking regulation and compliance practices. Your work will also involve aligning these external regulatory requirements with the company's existing compliance framework. A key responsibility will be building the materials necessary for applying for these authorisations based on the regulatory guidelines.

This internship offers an exceptional opportunity to kick off a career in fintech compliance at a growth company. You will gain first-hand, hands-on experience in how AML/CTF, payment fraud prevention, and information security frameworks are designed, implemented, and scaled using a lean three-lines-of-defence model. You will work with modern compliance tooling, including AI- and LLM-based solutions for regulatory analysis, risk assessment, and documentation. Your work will have clear ownership and high visibility, collaborating directly with company executives, and contributing to the company’s international expansion and long-term growth.

**This role is expected to provide a robust foundational topic and research material for a Master's thesis for students studying law or business.**

We expect you to:

-  be able to demonstrate strong analytical and research skills, relevant to the fields of law or business;

-  have experience in detailed analysis of complex documents or regulatory texts;

-  be able to communicate in English;

-  learn new regulatory frameworks and master domain expertise.

The following will be considered as an advantage:

-  basic knowledge about financial technology (fintech) regulation and compliance;

-  familiarity with the concept of Open Banking;

-  experience working with authorisation processes.

## About Enable Banking

Enable Banking Oy provides to its clients state of art Open Banking aggregation technology, connecting to over 2500 banks in 30 countries.

We develop high quality, secure software at a very fast pace. To be able to achieve this we rely on continuous integration and delivery, serverless cloud infrastructure, as well as automated testing and monitoring. We are ISO/IEC 27001 certified and are regulated by the Finnish supervisory authority (Finanssivalvonta).

Our customers are forerunners of Open Banking ranging from accounting software to neobanks core technology providers. Public references include Aura Cloud, Bolageriet, Isolta, Kreditz, Qred Bank and Zervant.

We are a venture-funded, fast growing fintech, operating from Espoo, Vilnius, and Stockholm.

## Got interested? Apply now → [hr@enablebanking.com](mailto:hr@enablebanking.com)
        </vue-markdown>
      </section>
    </main>
    <AsideFooter />
  </div>
</template>

<script>
import VueMarkdown from '@adapttive/vue-markdown'
import AsideFooter from '../components/AsideFooter.vue'
import Navbar from '../components/Navbar.vue'
import metadata from '../mixins/metadata.js'

export default {
  name: 'careers-regulatory-compliance-intern',
  mixins: [metadata],
  components: {
    AsideFooter,
    Navbar,
    VueMarkdown
  }
}
</script>

<style lang="scss">
.job-description h2 {
  margin-top: 3rem;
  margin-bottom: 2rem;
}
.bg-guy {
  background-image: url('../assets/img/dude.jpg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right center;
}
</style>
